export const API_MODEL_TYPE_AREA = 'area';